// extracted by mini-css-extract-plugin
export default {"errorMainClass":"style-module--errorMainClass--nNkP3"};